import { render, staticRenderFns } from "./About.vue?vue&type=template&id=5d1fa46b"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports